import React from 'react'
import { motion } from 'framer-motion'

const Button = ({ label, onClick, disabled }) => {
  return (
    <motion.button
      className="w-full p-4 rounded-2xl text-white cursor-pointer transition-all duration-300 bg-gradient-to-r from-[#1971FC] via-[#1971FC] to-[#9747FF]  hover:from-[#025AE3] hover:via-[#025AE3] hover:to-[#7B16FD] disabled:from-gray-300 disabled:via-gray-300 disabled:to-gray-300"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </motion.button>
  )
}

export default Button